import { LEARNING_GOAL_OPTIONS } from 'bundles/onboarding-common/constants';

import _t from 'i18n!nls/onboarding-common';

const getLearningGoalOptionName = () => ({
  [LEARNING_GOAL_OPTIONS.LEARNING_GOAL_LAND_NEW_JOB]: _t('Start my career'),
  [LEARNING_GOAL_OPTIONS.LEARNING_GOAL_CHANGE_CAREER]: _t('Change my career'),
  [LEARNING_GOAL_OPTIONS.LEARNING_GOAL_IMPROVE_SKILLS]: _t('Grow in my current role'),
  [LEARNING_GOAL_OPTIONS.LEARNING_GOAL_PERSONAL_INTEREST]: _t('Explore topics outside of work'),
});

export { getLearningGoalOptionName };
